import isEmpty from 'lodash.isempty';
import { useEffect, useRef, useState } from 'react';

import { getHeaderMenu } from '../../services';

const collectLeafChildren = (childrenArray) => (child2) => {
  if (isEmpty(child2.childrens)) {
    childrenArray.push(child2);
  }
};

const buildChildrenArray = (item) => {
  const childrenArray = [];
  item.childrens.map(collectLeafChildren(childrenArray));
  return childrenArray;
};

const formatLinkItem = (item, index) => ({
  ...item,
  id: index,
  childrenArray: buildChildrenArray(item),
});

const formattedData = (links) => links[0].childrens.map(formatLinkItem);

const handleHeaderMenuResponse = ({ isMounted, setStylingObjects, setMenuList, data }) => {
  if (isMounted.current && data) {
    const links = data.elements[0].fields.links;
    setStylingObjects(data.elements[0].fields.navigationFields);
    setMenuList(formattedData(links));
  }
};

const buildDropDownKeys = (menuList) => {
  const keys = menuList.map((dropdown) => dropdown.id);
  return keys.reduce((acc, curr) => {
    acc[curr] = false;
    return acc;
  }, {});
};

const GetHeaderMenu = () => {
  const isMounted = useRef(true);
  const [menuList, setMenuList] = useState([]);
  const [dropDownKeys, setDropDownKeys] = useState({});
  const [stylingObjects, setStylingObjects] = useState();

  useEffect(() => {
    getHeaderMenu()
      .then(({data}) => handleHeaderMenuResponse({ isMounted, setStylingObjects, setMenuList, data }))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isEmpty(menuList)) {
      return;
    }
    // set keys for dropdown
    setDropDownKeys(buildDropDownKeys(menuList));
  }, [menuList]);

  return { menuList, dropDownKeys, stylingObjects };
};

export default GetHeaderMenu;
